import { createUseStyles } from 'react-jss';

import styles from './styles';
import { TrackProps } from './types';

const useStyles = createUseStyles(styles);

const Track = ({ index, ...props }: TrackProps) => {
  const classes = useStyles({ index });

  return <div {...props} className={classes.track} />;
};

export default Track;
